import React, { useState } from "react";
import DataTable from "./DataTable";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card"; 
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useSystemTheme } from "context/SystemThemeContext";

const TotalEmails = () => {
  const { mode } = useSystemTheme();
  const isDarkMode = mode === "dark";
  
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(8);
  const [loading, setLoading] = useState(false);
  
  const handleEntriesChange = (newEntries) => {
    setEntriesPerPage(newEntries);
    setPage(1);
  };

  const columns = [
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "IP Address", accessor: "ip", align: "left" },
    { Header: "Location", accessor: "country_flag", align: "left" },
    { Header: "DATE & TIME", accessor: "created_at", align: "left" },
  ];
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ width: "100%", marginTop: "0px" }}>
        <Card sx={{
          backgroundColor: isDarkMode ? "#060C18" : "#ffffff",
          transition: "background-color 0.3s ease",
        }}>
          <SoftBox p={3} lineHeight={1.2}>
            {loading ? (
              <p style={{ textAlign: "center", color: isDarkMode ? "#e2e8f0" : "#1a202c" }}>Loading data...</p>
            ) : (
              <>
                <DataTable
                  table={{ columns, rows }}
                  entriesPerPage={{
                    defaultValue: entriesPerPage,
                    entries: [5, 10, 15],
                  }}
                  canSearch
                  date
                  csv
                  showTotalEntries
                  onEntriesChange={handleEntriesChange}
                  totalPages
                />  
              </>
            )}
          </SoftBox>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default TotalEmails;